import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Ensure URL is properly formatted with https://
const formattedUrl = supabaseUrl.startsWith('http') 
  ? supabaseUrl 
  : `https://${supabaseUrl}`;

export const supabase = createClient(formattedUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  // NOTE: no `global.headers` override here.
  //
  // We previously set `Content-Type: application/json` + `Accept: application/json`
  // globally. That was redundant for PostgREST / Auth (the SDK sets those
  // automatically), but it ALSO overrode the per-request Content-Type that
  // Supabase Storage uploads rely on — every storage upload was being sent
  // with `Content-Type: application/json`, and the storage server rejected
  // with "mime type application/json is not supported" no matter what file
  // the user picked. Surfaced 2026-06-01 when the new `email-images` bucket
  // went live; templates + campaigns failed every image upload until this
  // override was removed.
  db: {
    schema: 'public',
  },
});